import React, { useEffect, useState, useContext } from "react";
import { Modal, Select, Popconfirm, Spin, Table,notification  } from "antd"
import { PlusCircle } from "react-feather"
import { Link } from "react-router-dom"
import { getAllDesignations, createDesignationMethod, deleteDesignation } from "../../service/ApiServices"
import { API_BASE_URL } from "../../../src/environment"
import { ArrowLeft } from "lucide-react"
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";  
const Designation = () => {
  const { user } = useContext(UserContext);
  const [data, setData] = useState([])
  const [success, setSuccess] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [formData, setFormData] = useState({
    designationName: "",
  })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [search, setSearch] = useState("")
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const storedUserData = localStorage.getItem("user")
  const userData = JSON.parse(storedUserData)
  const id = userData?.data?.uid //
  const [userRightssub, setUserRightssub] = useState([])
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 })
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false)
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize)
  const pageSizeOptions = [5, 10, 20, 50, 100]
      const [api, contextHolder] = notification.useNotification();
    
      const showNotification = (type, message, description) => {
        api[type]({
          message,
          description,
          placement: 'topRight',
          duration: 4.5,
        });
      };

  useEffect(() => {
    const fetchUserRightssub = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/userright/${id}`)
        if (!response.ok) {
          throw new Error("Failed to fetch user rights")
        }
        const data = await response.json()
        console.log("Fetched User Sub Data:", data.data)
        setUserRightssub(data.data || []) // Ensure it's always an array
      } catch (error) {
        console.error("Error fetching data:", error)
        setUserRightssub([]) // Set to empty array in case of error
      }
    }

    fetchUserRightssub() // Fetch the data on component mount
  }, [id])
  const hasJobRightWithAdd = userRightssub.some((right) => right.right === "Designations" && right.adds === 1)
  //   const hasJobRightWithedit = userRightssub.some(right => right.right === 'Designations' && right.updates === 1);
  //  // const hasJobRightWithview = userRightssub.some(right => right.right === 'Designations' && right.viewes === 1);
  //   const hasJobRightWithedel = userRightssub.some(right => right.right === 'Designations' && right.deletes=== 1);
  // const hasJobRightWithdown = userRightssub.some(right => right.right === 'Designations' && right.fdownload=== 1);
  useEffect(() => {
    const handler = setTimeout(() => {
      const fetchData = async () => {
        getAllDesignations({ search, setLoading: setLoading2, setData })
      }
      fetchData()
    }, 600)

    return () => {
      clearTimeout(handler)
    }
  }, [search])

  useEffect(() => {
    if (success) {
      getAllDesignations({ search, setLoading: setLoading2, setData })
      showSuccess("Successfully saved Designation!")
      handleCancel()
      handleReset()
    }
    if (isDelete) {
      getAllDesignations({ search, setLoading: setLoading2, setData })
      showSuccess("Successfully deleted Department!")
    }
  }, [success, isDelete])

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setIsEdit(false)
  }

  const filteredData = data.filter((desig) => desig.designationName.toLowerCase().includes(search.toLowerCase()))

  const handleTableChange = (pagination) => {
    setPagination(pagination)
  }

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 }
    setPagination(newPagination)
    setPageSizeModalVisible(false)
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "designationName",
      key: "designationName",
      width: "700px",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
        {/* Edit Button */}
        <Link
          className={`me-2 p-2 ${
            user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "edit") 
              ? '' 
              : 'disabled'
          }`}
          to="#"
          onClick={() => {
            if (user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "edit")) {
              setFormData({
                id: record._id,
                designationName: record.designationName,
              });
              setIsEdit(true);
              setIsModalOpen(true);
            }
          }}
          title={
            !(user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "edit"))
              ? "You don't have permission to edit designations" 
              : "Edit designation"
          }
        >
          <i data-feather="download" className="feather-edit"></i>
        </Link>
  
        {/* Delete Button */}
        <Popconfirm
          title="Delete the Designation"
          description="Are you sure to delete this Designation?"
          onConfirm={() => {
            if (user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "delete")) {
              deleteDesignation({
                id: record._id,
                setIsDelete,
              });
            }
          }}
          onCancel={() => console.log("Cancelled")}
          okText="Yes"
          cancelText="No"
          disabled={
            !(user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "delete"))
          }
        >
          <Link 
            className={`confirm-text p-2 ${
              user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "delete") 
                ? '' 
                : 'disabled'
            }`}
            title={
              !(user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "delete"))
                ? "You don't have permission to delete designations" 
                : "Delete designation"
            }
          >
            <i data-feather="trash-2" className="feather-trash-2"></i>
          </Link>
        </Popconfirm>
      </td>
      ),
    },
  ]
  const handleSubmit = () => {
    if (formData.designationName === "") {
      alert("Please fill all fields")
      return
    }
    createDesignationMethod({
      data: formData,
      setLoading,
      setSuccess,
    })
  }
  const handleReset = () => {
    setFormData({
      id: "",
      designationName: "",
    })
  }

  const showSuccess = (str) => {
       showNotification('success', 'Good Job !', str);

  }
  return (
    <div className="page-wrapper-lt"> {contextHolder}
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container ">
              <div>
                <ArrowLeft size={32} />
              </div>

              <div className="page-title">
                <h4>Designations</h4>
                <h6>Manage your Designations</h6>
              </div>
            </div>
            <div className="page-btn">
  {!hasJobRightWithAdd && (
    <a 
      className={`btn btn-added ${
        user?.permissions && hasPermission(user.permissions, "HRM", "Designations", "create") 
          ? '' 
          : 'disabled'
      }`}
      onClick={() => {
        if (!hasJobRightWithAdd && user?.permissions && 
            hasPermission(user.permissions, "HRM", "Designations", "create")) {
          setIsModalOpen(true);
        }
      }}
      title={
        !(!hasJobRightWithAdd && user?.permissions && 
          hasPermission(user.permissions, "HRM", "Designations", "create"))
          ? "You don't have permission to add designations" 
          : "Add new designation"
      }
    >
      <PlusCircle className="me-2" />
      Add New
    </a>
  )}
</div>
          </div>
        </div>

        <div className="card table-list-card-grid">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <Link className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
                <div className="wordset">
                  <style>
                    {`
      @media (max-width: 767px) {
        .wordset {
          margin-bottom: 25px !important;
        }
      }
    `}
                  </style>
                  <ul>
                    {/* <li>
                      <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="pdf">
                        <img src="assets/img/icons/pdf.svg" alt="pdf" />
                      </a>
                    </li>
                    <li>
                      <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="excel">
                        <img src="assets/img/icons/excel.svg" alt="excel" />
                      </a>
                    </li> */}
                    <li>
                      <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="print">
                        <img src="assets/img/icons/printer.svg" alt="print" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <div className="search-set">
                <a href="#" className="btn btn-filter" id="filter_search">
                  <Sliders className="me-2" />Filter
                </a>
              </div> */}
            </div>
            <div className="table-responsive">
              <Table
                loading={loading2}
                columns={columns}
                dataSource={filteredData}
                rowKey="value"
                pagination={{
                  current: pagination.current,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  total: filteredData.length,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`
                }}
                onChange={handleTableChange}
                // footer={() => (
                //   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                //     <button className="btn btn-primary btn-sm" onClick={() => setPageSizeModalVisible(true)}>
                //       Change Page Size
                //     </button>
                //   </div>
                // )}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={200000}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{isEdit ? "Edit" : "Add"} Designation</h4>
                  <p className="mb-0">Fill in the required fields to create an Designation</p>
                </div>
              </div>
              <div className="modal-body custom-modal-body">
                <form>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Designation Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.designationName}
                          onChange={(e) => setFormData({ ...formData, designationName: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div className="">
                      <button type="button" className="btn btn-cancel me-2" onClick={handleReset}>
                        Reset
                      </button>
                      <button type="button" className="btn btn-submit ml-0" onClick={handleSubmit} disabled={loading}>
                        {loading ? <Spin size="small" /> : "Save"}
                      </button>
                    </div>

                    <button
                      type="button"
                      className="btn btn-cancel"
                      onClick={() => {
                        handleCancel()
                      }}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
            Cancel
          </button>,
          <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  )
}

export default Designation

